import React from 'react'

import FormRowFlex from "../../gd-form/form/form-flex/row"
import FormFlex from "../../gd-form/form/form-flex/form"
import FormModel from "../../gd-form/common/form-model-manager"
import FieldFormElement from "../../fields3/render/form-elemnent"
import FormFieldError from "../../gd-form/common/form-error/form-field-error"
import ButtonSubmit from "../../gd-form/common/btn-submit/btn-submit-ui5"
import ModalV4HeaderWhite from "../../../app/ui/modal/v4/header-white/v4-header-white"
import ProjectView_Link from "../../model2/project-view/views/link/link-view";

type Props = {
    params: {
        view : ProjectView_Link
    }
}

const debug = true
// const debug = "LinkProjectViewEditModal"

export default function LinkProjectViewEditModal(props:Props) {

    const stopPropagation = (e:React.MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()
    }

    const closeModal = () => {
        gd.modal.hide()
    }

    const onSubmit = async (model: ProjectView_Link) => {
        debug && console.log(debug, 'onSubmit', model)

        gd.projectViews.save()

        gd.modal.hide()
    }

    const form = new FormModel(props.params.view, {
        onSubmit        : onSubmit,
        isFormChanged   : true,
    })

    const labelWidth = 150

    return (
        <div className="v4-container placement-middle" onClick={stopPropagation}>
            <ModalV4HeaderWhite className       = "center-title p-t-60"
                                titleClassName  = "m-t-10"
                                height          = {90}
                                title           = "Edit Link view"
                                onClose         = {closeModal}/>
            <FormFlex className="p-t-30 p-l-50 p-r-50 p-b-50">
                <FormRowFlex label={gd.fields.projectView.name.label} width={labelWidth}>
                    <div className="flex-column-left-top">
                        <FieldFormElement className="w-300" field={gd.fields.projectView.name} form={form}/>
                        <FormFieldError form={form} fieldId={gd.fields.projectView.name.fieldId}/>
                    </div>
                </FormRowFlex>

                <FormRowFlex label={gd.fields.projectView.contentUrl.label} width={labelWidth}>
                    <div className="flex-column-left-top">
                        <FieldFormElement className="comments-field w-300" field={gd.fields.projectView.contentUrl} form={form}/>
                        <FormFieldError form={form} fieldId={gd.fields.projectView.contentUrl.fieldId}/>
                    </div>
                </FormRowFlex>

                <FormRowFlex className="m-t-30" width={labelWidth}>
                    <ButtonSubmit form={form} size="36" label="Submit"/>
                </FormRowFlex>
            </FormFlex>
        </div>
    )
}